import type React from 'react';

import { HomepageStaffDrawer } from '../components/HomepageStaffDrawer';
import { PageBody } from '../components/PageBody';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC<EmptyProps> = () => {
	useTrackPageView();

	return (
		<>
			<PageBody />
			<HomepageStaffDrawer />
		</>
	);
};
